module.exports = __webpack_public_path__ + "img/shelton-engineer-logo.34069908.jpg";